import React from 'react';
import { Alert, Button } from 'antd';

export default function CustomerPaymentBanner({ alertConfig }) {
  if (!alertConfig) return null;

  return (
    <Alert
      className="customer-preview-alert"
      showIcon
      type={alertConfig.type}
      action={alertConfig.action ? (
        <Button onClick={alertConfig.action.onClick}>
          {alertConfig.action.label}
        </Button>
      ) : null}
      message={(
        <span>
          <strong>{alertConfig.message}</strong>
          <span
            className={`customer-preview-alert-detail${
              alertConfig.mobileDescription ? ' has-mobile-detail' : ''
            }`}
          >
            <span className="customer-preview-alert-detail-full">
              {alertConfig.description}
            </span>
            {alertConfig.mobileDescription ? (
              <span className="customer-preview-alert-detail-mobile">
                {alertConfig.mobileDescription}
              </span>
            ) : null}
          </span>
        </span>
      )}
    />
  );
}
